/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmployeeAttribute
 */
export interface EmployeeAttribute {
    /**
     * 
     * @type {number}
     * @memberof EmployeeAttribute
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeAttribute
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeAttribute
     */
    name: string;
    /**
     * The status of the entity.
     * @type {string}
     * @memberof EmployeeAttribute
     */
    status: EmployeeAttributeStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof EmployeeAttribute
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof EmployeeAttribute
     */
    updatedAt: Date | null;
}

/**
* @export
* @enum {string}
*/
export enum EmployeeAttributeStatusEnum {
    Active = 'Active',
    Archived = 'Archived',
    Deleted = 'Deleted'
}


/**
 * Check if a given object implements the EmployeeAttribute interface.
 */
export function instanceOfEmployeeAttribute(value: object): value is EmployeeAttribute {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function EmployeeAttributeFromJSON(json: any): EmployeeAttribute {
    return EmployeeAttributeFromJSONTyped(json, false);
}

export function EmployeeAttributeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeAttribute {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'name': json['name'],
        'status': json['status'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
    };
}

  export function EmployeeAttributeToJSON(json: any): EmployeeAttribute {
      return EmployeeAttributeToJSONTyped(json, false);
  }

  export function EmployeeAttributeToJSONTyped(value?: EmployeeAttribute | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'name': value['name'],
        'status': value['status'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': (value['updatedAt'] == null ? null : (value['updatedAt'] as any).toISOString()),
    };
}

